import { fetchGigs } from '../../../utils/api/gigs';

export const GIGS_VIEW_ACTIONS = {
    LOAD_MORE: 'load_more_gigs',
    SET: 'set_gigs_view',
};

export const loadMoreGigs = () => async (dispatch, getState) => {
    const { gigsView } = getState();
    const { gigs, lastItemId } = gigsView;

    const { gigs: moreGigs, hasMorePages, lastItemId: newLastItemId } = await fetchGigs(lastItemId);

    const jointGigs = [...gigs, ...moreGigs];

    dispatch(
        setGigsView({
            gigs: jointGigs,
            hasMorePages,
            lastItemId: newLastItemId,
        })
    );
};

export const setGigsView = ({ gigs, hasMorePages, lastItemId }) => ({
    type: GIGS_VIEW_ACTIONS.SET,
    data: {
        gigs,
        hasMorePages,
        lastItemId,
    },
});
